import React from 'react';
import { ClassLeader6to82026 } from '../views';

const LifeSkillPage = () => {
  return <ClassLeader6to82026/>;
};

export default LifeSkillPage;